"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface SingleWaveDropInfoContainerProps {
  readonly children: React.ReactNode;
}
export const SingleWaveDropInfoContainer: React.FC<SingleWaveDropInfoContainerProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="@container tw-w-full tw-h-full tw-pt-20 lg:tw-pt-24 tw-bg-iron-950"><div className="tw-min-h-full tw-relative tw-bg-iron-950">{children}</div></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};